import config from '../../config'

import { IGetPutRequest } from '../../interfaces'

const getToggleLocationMutationRequest: IGetPutRequest = params => {
  const { airportId, id } = params

  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/Locations/${id}/ToggleIsActive`,
  }
}

export default getToggleLocationMutationRequest
